module.exports = __webpack_public_path__ + "img/sparkling_print.149a6854.png";